let appMode = process.env.REACT_APP_ENV;
let ASSET_URL =
  "https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/";
let URL;

console.log("appMode", appMode);

// 3.20.147.34

if (appMode === "development") {
  // URL = "http://103.189.173.7:5885/api/";
} else {
  // URL = "http://45.194.47.66:8015/api/v1/";
  URL = "https://gym.fusionhub.studio/api/v1/";
  // URL = "http://127.0.0.1:8000/api/v1/";
}

let apiPath = {
  baseURL: URL,
  assetURL: ASSET_URL,
  signUp: "gym_owner/sign_up",
  login: "gym_owner/portal_login",
  verifyOTP: "gym_owner/verify_otp",
  resendOTP:"gym_owner/resend_otp",
  forgotPassword: "gym_owner/forgot_password",
  resetPassword: "gym_owner/reset_password",
  resetPasswordWithToken: (token) => `gym_owner/reset_password/${token}`,
  changePassword: "gym_owner/change_password",
  profile: "gym_owner/profile",
  updateProfile: "gym_owner/update_profile",
  createWorkoutDay: "gym_owner/create_workout_day",
  getWorkoutDay: "gym_owner/get_workout_days", // Fixed endpoint name
  updateWorkoutDay: (day_id) => `gym_owner/update_workout_day/${day_id}`,
  deleteWorkoutDay: (day_id) => `gym_owner/delete_workout_day/${day_id}`,
  getAllWorkoutData: "gym_owner/all_workout_data",
  getWeeklyPlan: "gym_owner/get_weekly_workout_plan",
  updateBlock: "gym_owner/update_workout_plan",
  getStudioLinks: 'gym_owner/master/studio_links',
  pushToStudios: 'gym_owner/master/push',
  addBlock: "gym_owner/add_block/",
  deleteBlock: "gym_owner/delete_block/",
  uploadMedia: "gym_owner/upload_media",
  dashboard: "trainer/auth/dashboard",
  challenges: "trainer/challenges",
  meals: "trainer/meals",
  plans: "trainer/plans",
  workout: "trainer/workout",
  removeMedia: "gym_owner/remove_media",
  getMediaStream: "gym_owner/get_media_stream",
  updatePlanFromExcel: 'gym_owner/update_plan_from_excel',
  uploadLogo : 'gym_owner/upload_logo',
};

export default apiPath;
